import React from 'react'
import IconSVG from 'svg-inline-react'
import { Link } from 'react-router'
import { CUTOVER_SETTINGS_ROUTES } from 'components/settings/Routing/constants.js'
import { APP_URL } from 'constants/ResourcesConstants'
import ACCESS from 'utils/Access'

import style from './style.styl'
import backButtonSrc from '!svg-inline?removeTags=true!images/icons/caret-icon.svg'

const BackButton = ({ url, title }) => {
  const relativePath = url.replace('/settings', '')
  const pathObj = CUTOVER_SETTINGS_ROUTES.find(function(route) { return route.path === relativePath })
  const shouldRedirect = pathObj && (!pathObj.requiredGate || ACCESS.hasGates(pathObj.requiredGate))

  const linkProps = shouldRedirect
    ? { href: `${APP_URL}/settings2${relativePath}` }
    : { to: `${url}` }

  return (
    <Link
      className={style.BackButton}
      {...linkProps}
    >
      <IconSVG src={backButtonSrc} />
      {title}
    </Link>
  )
}

export default BackButton



// WEBPACK FOOTER //
// ./src/scripts/components/settings/ChatWidget/components/BackButton/index.js